import firebase from 'firebase/compat/app';
import { DASHBOARDS_COLLECTION } from '../constants';
import withoutNulls from '../api/search/withoutNulls';
import {
  migrateDashboardIsV3Published,
  migrateDashboardV3Access,
} from '../screens/Settings/Advanced/V3Migrators/ContentV3AccessMigrator/utils';

const dashboardConverter = {
  toFirestore(dashboard: DashboardType): firebase.firestore.DocumentData {
    return withoutNulls(dashboard);
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<DashboardType>,
    options: firebase.firestore.SnapshotOptions,
  ): DashboardType {
    const dashboard = snapshot.data(options);
    dashboard.variableDrillDowns = dashboard.variableDrillDowns.map((v) => ({
      ...v,
      type: 'Variable',
    }));

    dashboard.v3Access = dashboard.v3Access
      ? dashboard.v3Access
      : migrateDashboardV3Access(dashboard);

    dashboard.isV3Published =
      dashboard.isV3Published !== undefined
        ? dashboard.isV3Published
        : migrateDashboardIsV3Published(dashboard);

    dashboard.labelIds = dashboard.labelIds || [];

    return dashboard;
  },
};

const getDashboardsRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(DASHBOARDS_COLLECTION)
    .withConverter(dashboardConverter);
};

export default getDashboardsRef;
